// JavaScript Document

// ---- サイト内検索の言い換え（#778）----
// 管理画面のメタオブジェクト「検索の言い換え」（search_synonym）を辞書にして、
// 検索語を言い換えてから検索する（例: ぎょくろ → 玉露）。
// 辞書は snippets/header-search.liquid が #ymy-search-synonyms に JSON で書き出す。
// 効かせる所: (a) 打っている途中の候補（theme.js から rewrite を呼ぶ）
//             (b) 検索窓から送ったとき (c) /search?q=… を直接開いたとき
// 辞書が読めない・空のときは何もしない（今と同じ検索になる）。
(function () {
  function toKey(word) {
    return word.normalize('NFKC').toLowerCase();
  }

  // ---- 辞書を作る（design 4-1）----
  // to が空のグループは捨てる／同じ from は先のグループを使う／
  // to が別グループの from にも入っていたら、その from を捨てる（言い換えの言い換えをしない）
  function buildDictionary(groups) {
    const dictionary = new Map();
    if (!Array.isArray(groups)) return dictionary;

    const targets = [];
    groups.forEach(function (group) {
      if (!group || typeof group.to !== 'string' || !Array.isArray(group.from)) return;
      const to = group.to.normalize('NFKC').trim();
      if (to === '') return;
      targets.push(to);

      group.from.forEach(function (word) {
        if (typeof word !== 'string') return;
        const key = toKey(word.trim());
        if (key === '') return;
        if (dictionary.has(key)) {
          if (dictionary.get(key) !== to) console.warn('[search-synonyms] 同じ言い換え元が2つのグループにあります: ' + word);
          return;
        }
        dictionary.set(key, to);
      });
    });

    // 言い換え先そのものと、言い換え先の中の語（「玉露 茶」なら「玉露」「茶」）は言い換え元にしない。
    // 残すと、言い換えた結果がもう一度言い換わり、検索ページの移動が止まらなくなる
    targets.forEach(function (to) {
      [to].concat(to.split(/\s+/)).forEach(function (word) {
        const key = toKey(word);
        if (key === '' || !dictionary.has(key)) return;
        if (dictionary.get(key) !== to || word !== to) {
          console.warn('[search-synonyms] 言い換え先に含まれる語は言い換え元にできません: ' + word);
        }
        dictionary.delete(key);
      });
    });

    return dictionary;
  }

  // ---- 言い換える（design 4-2）----
  // 空白（半角・全角）で区切った語ごとに、辞書と完全に一致したら置き換える。
  // 一致しない語と空白は打ったまま残す。1語も置き換わらなければ元の検索語を返す。
  function rewriteTerm(term, dictionary) {
    if (typeof term !== 'string' || dictionary.size === 0) return term;

    let changed = false;
    const parts = term.split(/(\s+)/).map(function (part) {
      if (part === '' || /^\s+$/.test(part)) return part;
      const to = dictionary.get(toKey(part));
      if (to === undefined) return part;
      changed = true;
      return to;
    });

    return changed ? parts.join('') : term;
  }

  function readDictionary() {
    const element = document.getElementById('ymy-search-synonyms');
    if (!element) return new Map();
    try {
      return buildDictionary(JSON.parse(element.textContent));
    } catch (error) {
      console.warn('[search-synonyms] 辞書を読めませんでした', error);
      return new Map();
    }
  }

  function isSearchPath(pathname) {
    return /\/search\/?$/.test(pathname);
  }

  function init() {
    if (window.ymySearchSynonyms) return; // ヘッダーが2回出ても1回だけ
    const dictionary = readDictionary();
    const rewrite = function (term) {
      return rewriteTerm(term, dictionary);
    };

    // (a) theme.js の predictive-search がこれを呼ぶ
    window.ymySearchSynonyms = { rewrite: rewrite };
    if (dictionary.size === 0) return;

    // (b) 検索窓から送ったとき: 入力欄 q の値そのものを言い換える（hidden input は足さない）
    document.addEventListener('submit', function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!isSearchPath(new URL(form.getAttribute('action') || '', location.href).pathname)) return;
      const input = form.elements.namedItem('q');
      if (!(input instanceof HTMLInputElement)) return;
      const rewritten = rewrite(input.value);
      if (rewritten !== input.value) input.value = rewritten;
    }, true);

    // (c) /search?q=… を直接開いたとき: q だけを言い換えて移る（ほかの条件は残す）
    if (isSearchPath(location.pathname)) {
      const url = new URL(location.href);
      const term = url.searchParams.get('q');
      if (term !== null) {
        const rewritten = rewrite(term);
        // 言い換えた結果がもう一度言い換わるなら移らない（移動が止まらなくなるのを防ぐ）
        if (rewritten !== term && rewrite(rewritten) === rewritten) {
          url.searchParams.set('q', rewritten);
          location.replace(url.toString());
        }
      }
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    // node での確かめ用（ブラウザでは使わない）
    module.exports = { buildDictionary: buildDictionary, rewriteTerm: rewriteTerm };
  } else {
    init();
  }
})();
